export default class MongoNotificationProjectLaunched {
  projectId = "";
  projectTitle = "";
  projectLogoUrl = "";

  launcherId = "";
  launcherName = "";
  launcherLogoUrl = "";
}
